/*
 * @file tracks if user hits print command
 */
import { trackEvent } from 'bits/analytics'

const track = (): void => trackEvent('Surface', 'Print Dialog')

export function trackPrinting(): void {
  if (window.matchMedia) {
    const mediaQueryList = window.matchMedia('print')
    mediaQueryList.addEventListener('change', (mql) => {
      if (mql.matches) {
        track()
      }
    })
  }
  window.onbeforeprint = track
}
